import { skipToken } from '@reduxjs/toolkit/query';
import { useAppSelector } from '../app/useAppSelector';
import { useGetWebtextManifestByCourseIdQuery } from '../../queries/courses';
import { selectCourseId } from '../../selectors/application';

export const useWebtextManifest = () => {
  const courseId = useAppSelector(selectCourseId);
  return useGetWebtextManifestByCourseIdQuery(!courseId ? skipToken : courseId);
};
